import { User as UserIcon } from "lucide-react"
import { useAuth } from "@/hooks"

/**
 * User component displays the current user's information with a dropdown menu.
 * Shows credits, settings, and sign out options.
 * Only renders when a user is authenticated.
 */
export function User() {
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  const displayName = user?.user_metadata.name?.split(" ")[0] ?? user?.email ?? 'Stranger';
  const email = user?.email;

  return (
    <div className="flex items-center gap-2">
      <div className="h-8 w-8 rounded-full bg-primary/10 flex items-center justify-center">
        <UserIcon className="h-4 w-4 text-primary" />
      </div>
      <div className="flex flex-col">
        <span className="text-sm font-medium hidden md:inline-block">
          {displayName}
        </span>
        <span className="text-xs text-muted-foreground hidden md:inline-block">
          {email}
        </span>
      </div>
    </div>
  );
}
